export type OutlookTimeSlotOption = { id: number; label: string; value: string };

export const OUTLOOK_MEETING_DEFAULT_START_TIME = '10:00';
export const OUTLOOK_MEETING_DEFAULT_END_TIME = '23:00';

const pad2 = (n: number) => String(n).padStart(2, '0');

export const OUTLOOK_TIME_SLOT_OPTIONS: OutlookTimeSlotOption[] = Array.from({ length: 48 }, (_, i) => {
  const hours = Math.floor(i / 2);
  const minutes = i % 2 === 0 ? 0 : 30;
  const label = `${pad2(hours)}:${pad2(minutes)}`;
  return { id: i, label, value: label };
});

export const findTimeSlotFromDate = (dateStr: string | null): OutlookTimeSlotOption | null => {
  if (!dateStr) return null;

  const date = new Date(dateStr + 'Z');
  const hours = date.getHours();
  const minutes = date.getMinutes() >= 30 ? 30 : 0;
  const label = `${pad2(hours)}:${pad2(minutes)}`;

  return OUTLOOK_TIME_SLOT_OPTIONS.find((opt) => opt.value === label) ?? null;
};
